import React from 'react';
import {Image, Text, TouchableOpacity} from 'react-native';
import {IBrand} from '../../../../../types/Filter';
import {styles} from './styles';

interface ICard {
  item: IBrand;
  onPress: (val: string) => void;
}

const Card = ({item, onPress}: ICard) => {
  return (
    <TouchableOpacity
      onPress={() => onPress(item?.name)}
      style={{
        marginHorizontal: 10,
      }}>
      <Image source={{uri: item.url}} style={{width: 80, height: 80}} />
      <Text style={styles.text}>{item?.name}</Text>
    </TouchableOpacity>
  );
};

export default Card;
